import { useQuery } from '@apollo/client';
import React, { FC } from 'react';
import { Box, Heading } from '@bechtel/gds';
import { ThreeWLAWeekHeaderContainerStyled, ThreeWLAColumnStyled, CurrentWeekStyled } from './styled';
import { PlanningWeekStats, PlanningFilterInput } from '@bechtel/types';
import { GET_PLANNING_WEEKS } from '@bechtel/client-gql';
import { StatsSpinner, ErrorRetry } from '@bechtel/client-common';
import { Trans } from '@lingui/macro';
export const ThreeWLAWeekHeader: FC = () => {
  const { loading, error, data, refetch } = useQuery<
    { planningWeekStats: PlanningWeekStats[] },
    { input: PlanningFilterInput }
  >(GET_PLANNING_WEEKS, {
    variables: {
      input: {
        numPreviousWeeks: 1,
        numNextWeeks: 2,
      },
    },
  });
  return (
    <ThreeWLAWeekHeaderContainerStyled data-testid="crew-header">
      <ThreeWLAColumnStyled>
        <Heading size="300" weight="600">
          <Trans>Crew</Trans>
        </Heading>
      </ThreeWLAColumnStyled>
      {!loading && error && (
        <Box alignItems={{ sm: 'center' }} justifyContent={{ sm: 'center' }} py={{ sm: '900' }} flexGrow={{ sm: 1 }}>
          <ErrorRetry refetch={refetch}>
            <Trans>There was error loading looka ahead weeks. Please click the button below to try again.</Trans>
          </ErrorRetry>
        </Box>
      )}
      {(loading || data) && (
        <>
          <ThreeWLAColumnStyled data-testid="week-1">
            <Heading size="300" weight="600">
              <Trans>Week</Trans>
            </Heading>
            <Box pl={{ sm: '200' }}>
              {loading ? (
                <StatsSpinner />
              ) : (
                <Heading size="300" weight="600">
                  {data?.planningWeekStats[0].weekNumber}
                </Heading>
              )}
            </Box>
          </ThreeWLAColumnStyled>
          <ThreeWLAColumnStyled style={{ position: 'relative' }} data-testid="week-2">
            <Heading size="300" weight="600">
              <Trans>Week</Trans>
            </Heading>
            <Box pl={{ sm: '200' }} style={{ position: 'absolute', top: '10px', left: '48px' }}>
              {loading ? (
                <StatsSpinner />
              ) : (
                <CurrentWeekStyled>
                  <Heading size="300" weight="600">
                    {data?.planningWeekStats[1].weekNumber}
                  </Heading>
                </CurrentWeekStyled>
              )}
            </Box>
          </ThreeWLAColumnStyled>
          <ThreeWLAColumnStyled data-testid="week-3">
            <Heading size="300" weight="600">
              <Trans>Week</Trans>
            </Heading>
            <Box pl={{ sm: '200' }}>
              {loading ? (
                <StatsSpinner />
              ) : (
                <Heading size="300" weight="600">
                  {data?.planningWeekStats[2].weekNumber}
                </Heading>
              )}
            </Box>
          </ThreeWLAColumnStyled>
          <ThreeWLAColumnStyled data-testid="week-4">
            <Heading size="300" weight="600">
              <Trans>Week</Trans>
            </Heading>
            <Box pl={{ sm: '200' }}>
              {loading ? (
                <StatsSpinner />
              ) : (
                <Heading size="300" weight="600">
                  {data?.planningWeekStats[3].weekNumber}
                </Heading>
              )}
            </Box>
          </ThreeWLAColumnStyled>
        </>
      )}
    </ThreeWLAWeekHeaderContainerStyled>
  );
};
